import { Lightning, Clock, ChatCenteredText, Phone, Envelope, Users } from '@/app/components/Icons/Phosphoricons'

const features = [
    {
        name: 'Automation',
        description:
            'Reduce manual workloads by implementing intelligent process automation, enabling teams to focus on high value tasks.',
        icon: Lightning,
    },
    {
        name: 'AI Agents',
        description:
            'Leverage AI driven virtual assistants to handle tasks, provide customer support, and automate decision making processes.',
        icon: Clock,
    },
    {
        name: 'Email Solutions',
        description:
            'Secure and scalable email communication powered by cloud based infrastructure for seamless business communication.',
        icon: Envelope,
    },
    {
        name: 'Phone Solutions',
        description:
            'Cloudbased telephony systems provide reliable, scalable voice communication for businesses of all sizes.',
        icon: Phone,
    },
    {
        name: 'Chat Solutions',
        description:
            'Real time messaging platforms enhance customer engagement and internal collaboration across your organization.',
        icon: ChatCenteredText,
    },
    {
        name: 'Consulting',
        description:
            'Expert guidance to optimize technology adoption and streamline digital transformation for your business needs.',
        icon: Users,
    },
]

export default function HighlightsBTS() {
    return (
        <div className="bg-white py-24 sm:py-32">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <div className="mx-auto max-w-2xl lg:text-center">
                    <h2 className="text-base/7 font-semibold text-blue-600">Business Technology Tools</h2>
                    <p className="mt-2 text-4xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-5xl lg:text-balance">
                        Optimize Operations with Scalable Solutions
                    </p>
                    <p className="mt-6 text-lg/8 text-gray-600">
                        Empower your business with cutting edge technology solutions designed for automation,
                        communication, and efficiency that provide the foundation for long term growth.
                    </p>
                </div>
                <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-4xl">
                    <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-10 lg:max-w-none lg:grid-cols-2 lg:gap-y-16">
                        {features.map((feature) => (
                            <div key={feature.name} className="relative pl-16">
                                <dt className="text-base/7 font-semibold text-gray-900">
                                    <div className="absolute top-0 left-0 flex size-10 items-center justify-center rounded-lg bg-blue-600">
                                        <feature.icon aria-hidden="true" className="size-6 text-white" weight="light" />
                                    </div>
                                    {feature.name}
                                </dt>
                                <dd className="mt-2 text-base/7 text-gray-600">{feature.description}</dd>
                            </div>
                        ))}
                    </dl>
                </div>
            </div>
        </div>
    )
}
